/* eslint-disable @typescript-eslint/no-explicit-any */
// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

const ViewGiftCard = dynamic(() => import('./ViewGiftCard').then(mod => mod.ViewGiftCard));

export const ViewGiftCardConfig = {
  emptyLabel: 'viewGiftCard',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/viewgiftcard`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ViewGiftCardEditable = (props: any) => (
  <EditableComponent config={ViewGiftCardConfig} {...props}>
    <ViewGiftCard {...props} />
  </EditableComponent>
);
